<template>
  <page-outline :title="pageTitle" :useMainContent="false">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <alerts-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></alerts-form>
      </b-container>
    </template>
    
    <template slot="bottomActions">
      <!-- Mode édition - Bouton Annuler -->
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.cncl')"
        variant="secondary"
        custom-class="mr-3"
        @click="switchMode('details')">
      </app-button>
      
      <!-- Mode détails - Bouton Modifier -->
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        custom-class="mr-3"
        @click="switchMode('edit')">
      </app-button>
      
      <!-- Mode détails - Bouton Supprimer -->
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        @click="deleteAlerts">
      </app-button>
      
      <!-- Mode édition - Bouton Enregistrer -->
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="editAlerts">
      </app-button>
      
      <!-- Mode ajout - Bouton Enregistrer -->
      <app-button
        v-if="mode === 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="addAlerts">
      </app-button>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import AlertsForm from '@/pages/alerts/AlertsForm.vue'
import AppButton from '@/components/common/AppButton.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "AlertsDetails",
  components: {
    'alerts-form': AlertsForm,
    'page-outline': PageOutline,
    'app-button': AppButton,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.alert_configuration_edit')
        case 'details':
          return this.$t('Webheader.alert_configuration_details')
        case 'add':
        default:
          return this.$t('Webheader.alert_configuration_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      alerts: '',
      returnUrl: '',
      currentAlerts: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/alerts/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getAlerts()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addAlerts () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.config.Name,
        IdMetricsKey: this.config.IdMetricsKey,
        ThresholdHigh: this.config.ThresholdHigh,
        ThresholdLow: this.config.ThresholdLow,
        IdThresholdUnit: this.config.IdThresholdUnit,
        // desactiver pour lot 1
        // IdEmailGroupName: this.config.selectedGroupNames.map(group => group.id).join(', '),
        Description: this.config.Description,
        Criticality: this.config.Criticality,
        id: this.id
      }
      this.$engine.firstOn().alerts.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.alerts.alert_configuration_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/alerts/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.alerts.name_exist_db'))
            } else if (error.error === "Duplicate Criticality") {
              that.okMessageBox(that.$t('common.alerts.critical_exist_db'))
            } else if (error.error === "Invalid ThresholdHigh") {
              that.okMessageBox(that.$t('common.alerts.threshold_high_invalid'))
            } else if (error.error === "Invalid ThresholdLow") {
              that.okMessageBox(that.$t('common.alerts.threshold_low_invalid'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    deleteAlerts () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.alerts.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdAlerts: that.id
              }
              that.$engine.firstOn().alerts.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.alerts.alert_configuration_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/alerts/'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.alerts.alert_configuration_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editAlerts () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        Name: this.config.Name,
        IdMetricsKey: this.config.IdMetricsKey,
        ThresholdHigh: this.config.ThresholdHigh,
        ThresholdLow: this.config.ThresholdLow,
        IdThresholdUnit: this.config.IdThresholdUnit,
        // desactiver pour lot 1
        // IdEmailGroupName: this.config.selectedGroupNames.map(group => group.id).join(', '),
        Description: this.config.Description,
        Criticality: this.config.Criticality,
        IdAlerts: this.id
      }
      this.$engine.firstOn().alerts.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.alerts.alert_configuration_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/alerts/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.alerts.name_exist_db'))
            } else if (error.error === "Duplicate Criticality") {
              that.okMessageBox(that.$t('common.alerts.critical_exist_db'))
            } else if (error.error === "Invalid ThresholdHigh") {
              that.okMessageBox(that.$t('common.alerts.threshold_high_invalid'))
            } else if (error.error === "Invalid ThresholdLow") {
              that.okMessageBox(that.$t('common.alerts.threshold_low_invalid'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentAlerts
      this.originalConfig = this.currentAlerts
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.Name === undefined || this.config.Name === '') {
        this.okMessageBox(this.$t('common.alerts.name_missing'))
        return true
      }
      if (this.config.IdMetricsKey === undefined || this.config.IdMetricsKey === '') {
        this.okMessageBox(this.$t('common.alerts.metrics_key_missing'))
        return true
      }
      if (this.config.IdThresholdUnit === undefined || this.config.IdThresholdUnit === '') {
        this.okMessageBox(this.$t('common.alerts.threshold_unit_missing'))
        return true
      }
      // Check ThresholdLow
      if (this.config.ThresholdLow === undefined || this.config.ThresholdLow === null || this.config.ThresholdLow === '') {
        this.okMessageBox(this.$t('common.alerts.threshold_low_missing'))
        return true
      }
      // Validate numeric value
      if (!this.isNumeric(String(this.config.ThresholdLow))) {
        this.okMessageBox(this.$t('common.alerts.threshold_low_invalid'))
        return true
      }
      // Check ThresholdHigh
      if (this.config.ThresholdHigh === undefined || this.config.ThresholdHigh === null || this.config.ThresholdHigh === '') {
        this.okMessageBox(this.$t('common.alerts.threshold_high_missing'))
        return true
      }
      // Validate numeric value
      if (!this.isNumeric(String(this.config.ThresholdHigh))) {
        this.okMessageBox(this.$t('common.alerts.threshold_high_invalid'))
        return true
      }
      // if (this.config.IdEmailGroupName === undefined || this.config.IdEmailGroupName === '') {
      //   this.okMessageBox(this.$t('common.email.email_address_missing'))
      //   return true
      // }
      // if (this.config.Description === undefined || this.config.Description === '') {
      //   this.okMessageBox(this.$t('common.alerts.description_missing'))
      //   return true
      // }
      if (this.config.Criticality === undefined) {
        this.okMessageBox(this.$t('common.alerts.criticality_level_missing'))
        return true
      }
      return false
    },
    getAlerts () {
      this.$engine.firstOn().alerts.fetch({id: this.id})
      .then(resp => {
        let that = this
        let alertsList = {}

        alertsList = resp.data.Alerts

        that.updateAlerts(alertsList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    goBack() {
      loadPage(this, {url: this.returnUrl})
    },
    updateAlerts(alertsList){
      const selectedAlerts = alertsList.find(alerts => alerts.IdAlerts === this.id)
      this.currentAlerts = selectedAlerts
      this.fillFields()
    },
    isNumeric(value) {
      // Check if the value is a valid number (including negative numbers and decimals)
      // Reject scientific notation (e.g., 1e3) and standalone 'e'
      const strValue = String(value).trim()
      
      // Empty string is not numeric
      if (strValue === '') {
        return false
      }
      
      // Reject if contains 'e' (scientific notation)
      if (strValue.toLowerCase().includes('e')) {
        return false
      }
      
      // Check if it's a valid number format
      return /^-?\d*\.?\d+$/.test(strValue)
    }
  }
}
</script>
